export default __webpack_public_path__ + "static/media/video-question-troubleshoot-2.961a563c.png";